 $(document).ready(function() {
      const $carouselList = $('.carousel-list');
      const $projectItems = $('.carousel-item');
      
      // Simple direct hover control - show the corresponding image
      $('.project-item').on('mouseenter', function() {
        const index = $(this).data('index');
        
        // Show the corresponding image
        $carouselList.css('transform', `translateX(-${index * 650}px) rotate(-20deg)`);
        $projectItems.css('transform', `rotate(-22.5deg) scale(1.1, 1.1)`);
      });
      
      // Reset to first image when leaving the project list area
      $('.project-list').on('mouseleave', function() {
        $projectItems.css('transform', 'translateX(0) rotate(-30deg)');
      });
    });
    $(document).ready(function() {
      const $carouselList = $('.carousel-list');
      const $tabSlider = $('#tab-slider');
      
      if ($tabSlider.length === 0) return;

      const el = $tabSlider.get(0);
      const cs = window.getComputedStyle(el);
      const originalBackground = cs.getPropertyValue('--themed-background').trim();
      const originalForeground = cs.getPropertyValue('--themed-foreground').trim();
      
      // Custom theme colors for each project
      const projectThemes = [
          { background: '#3A2E39', foreground: '#0F0F0F' },  // Default theme
        { background: '#2C3E50', foreground: '#F4EBE8' },  // Purple theme
        { background: '#2D2D2D', foreground: '#ECF0F1' }   // Blue theme
      ];
      
      // Simple direct hover control - show the corresponding image and change background
      $('.project-item').on('mouseenter', function() {
        const index = $(this).data('index');
        
        // Transform the carousel list
        $carouselList.css('transform', `translateX(-${index * 650}px)`);
        
        // Change the section background and foreground colors
        if (index < projectThemes.length) {
          $tabSlider.css('--themed-background', projectThemes[index].background);
          $tabSlider.css('--themed-foreground', projectThemes[index].foreground);
        }
      });
      
      // Reset to first image and original colors when leaving the project list area
      $('.project-list').on('mouseleave', function() {
        $carouselList.css('transform', 'translateX(0)');
        
        // Reset to original theme colors
        $tabSlider.css('--themed-background', originalBackground);
        $tabSlider.css('--themed-foreground', originalForeground);
      });
      $('.project-item a').on('click', function(e) {
        e.stopPropagation(); // prevent hover effects from interfering
      });
    });